module.exports = __webpack_public_path__ + "fonts/KeepIconRegular.f76b8ac1.woff";